export const base = 'gateway/main';
export const baseODATA = 'gateway/mainodata';

export const getAllServicePlan = `${base}/servicePlan`;
export const getQueryODATA = `${baseODATA}/serviceplansearchquery`;
export const getServicePlanById = `${base}/servicePlan`;
export const postServicePlan = `${base}/servicePlan`;
